
import { useState } from 'react';
import Button from '../../../components/base/Button';

export default function NewsGridSection() {
  const [activeFilter, setActiveFilter] = useState('All');

  const filters = ['All', 'Policy', 'Education', 'Community', 'Research', 'Events'];

  const newsArticles = [
    {
      title: "Ontario Expands Pharmacist Prescribing Authority for Mental Health Medications",
      summary: "New regulations allow pharmacists to prescribe and adjust mental health medications under collaborative care agreements.",
      author: "Dr. Jennifer Liu",
      date: "January 15, 2025",
      category: "Policy",
      readTime: "5 min",
      image: "https://public.readdy.ai/ai/img_res/8d7c30cb667487b17a4fbaa80d66a09a.jpg"
    },
    {
      title: "Veterinary Telehealth Platform Reaches 1 Million Consultations",
      summary: "National veterinary telehealth initiative achieves milestone, improving access to specialized care in rural areas.",
      author: "Dr. Marcus Thompson",
      date: "January 14, 2025",
      category: "Community",
      readTime: "4 min",
      image: "https://readdy.ai/api/search-image?query=Veterinarian%20conducting%20telehealth%20consultation%20with%20pet%20owner%20via%20video%20call%2C%20digital%20healthcare%20technology%2C%20remote%20veterinary%20care%2C%20modern%20veterinary%20clinic%20with%20technology%20setup&width=400&height=250&seq=news6&orientation=landscape"
    },
    {
      title: "New Research Shows Collaborative Care Reduces Hospital Readmissions by 35%",
      summary: "Multi-year study demonstrates significant improvement in patient outcomes when pharmacists and veterinarians work together.",
      author: "Dr. Emily Rodriguez",
      date: "January 13, 2025",
      category: "Research",
      readTime: "7 min",
      image: "https://readdy.ai/api/search-image?query=Healthcare%20research%20team%20analyzing%20patient%20outcome%20data%2C%20medical%20researchers%20reviewing%20collaborative%20care%20statistics%2C%20healthcare%20professionals%20studying%20research%20results%2C%20modern%20research%20laboratory%20setting&width=400&height=250&seq=news7&orientation=landscape"
    },
    {
      title: "CPVA Launches Indigenous Health Scholarship Program",
      summary: "New $500,000 scholarship fund supports Indigenous students pursuing pharmacy and veterinary medicine careers.",
      author: "Sarah McKenzie",
      date: "January 12, 2025",
      category: "Education",
      readTime: "3 min",
      image: "https://readdy.ai/api/search-image?query=Indigenous%20students%20in%20healthcare%20education%20program%2C%20diverse%20pharmacy%20and%20veterinary%20students%20in%20classroom%2C%20scholarship%20recipients%20celebrating%20achievement%2C%20educational%20diversity%20in%20healthcare&width=400&height=250&seq=news8&orientation=landscape"
    },
    {
      title: "Quebec Pilots One Health Approach in Five Regional Health Networks",
      summary: "Innovative program integrates human and animal health services to address zoonotic disease prevention.",
      author: "Dr. Antoine Dubois",
      date: "January 11, 2025",
      category: "Policy",
      readTime: "6 min",
      image: "https://readdy.ai/api/search-image?query=One%20Health%20program%20meeting%20with%20healthcare%20professionals%2C%20veterinarians%20and%20pharmacists%20collaborating%20on%20zoonotic%20disease%20prevention%2C%20integrated%20healthcare%20approach%2C%20regional%20health%20network%20meeting&width=400&height=250&seq=news9&orientation=landscape"
    },
    {
      title: "National Conference on Pain Management Protocols Announces Key Speakers",
      summary: "Leading experts in human and veterinary pain management to present latest research and treatment guidelines.",
      author: "Conference Committee",
      date: "January 10, 2025",
      category: "Events",
      readTime: "2 min",
      image: "https://readdy.ai/api/search-image?query=Medical%20conference%20presentation%20on%20pain%20management%2C%20healthcare%20professionals%20attending%20educational%20seminar%2C%20conference%20speakers%20presenting%20to%20audience%2C%20professional%20medical%20education%20event&width=400&height=250&seq=news10&orientation=landscape"
    },
    {
      title: "Alberta Pharmacy-Veterinary Partnership Wins National Innovation Award",
      summary: "Calgary-based collaboration recognized for developing novel approach to antimicrobial stewardship.",
      author: "Awards Committee",
      date: "January 9, 2025",
      category: "Community",
      readTime: "4 min",
      image: "https://readdy.ai/api/search-image?query=Healthcare%20professionals%20receiving%20innovation%20award%2C%20pharmacy%20and%20veterinary%20team%20accepting%20recognition%2C%20professional%20achievement%20ceremony%2C%20healthcare%20innovation%20celebration&width=400&height=250&seq=news11&orientation=landscape"
    },
    {
      title: "New CE Modules Focus on Climate Change and Health Impacts",
      summary: "Continuing education programs address emerging health challenges related to environmental changes.",
      author: "Education Team",
      date: "January 8, 2025",
      category: "Education",
      readTime: "5 min",
      image: "https://readdy.ai/api/search-image?query=Healthcare%20professionals%20in%20continuing%20education%20seminar%20about%20climate%20change%20and%20health%2C%20environmental%20health%20training%20session%2C%20professional%20development%20workshop%2C%20modern%20educational%20facility&width=400&height=250&seq=news12&orientation=landscape"
    },
    {
      title: "Research Grant Awarded for Antibiotic Resistance Study",
      summary: "$2.1 million federal grant supports collaborative research on antimicrobial resistance in companion animals.",
      author: "Dr. Rachel Chen",
      date: "January 7, 2025",
      category: "Research",
      readTime: "6 min",
      image: "https://readdy.ai/api/search-image?query=Research%20laboratory%20studying%20antibiotic%20resistance%2C%20scientists%20conducting%20antimicrobial%20research%2C%20veterinary%20research%20facility%2C%20medical%20research%20team%20working%20with%20laboratory%20equipment&width=400&height=250&seq=news13&orientation=landscape"
    }
  ];

  const filteredArticles = activeFilter === 'All' 
    ? newsArticles 
    : newsArticles.filter(article => article.category === activeFilter);

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Latest News
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Stay up-to-date with the most important developments in pharmacy, veterinary medicine, and healthcare policy
          </p>
        </div>

        {/* Filter Tabs */}
        <div className="flex flex-wrap justify-center gap-2 mb-12">
          {filters.map((filter) => (
            <button
              key={filter}
              onClick={() => setActiveFilter(filter)}
              className={`px-6 py-3 rounded-full font-medium transition-all whitespace-nowrap cursor-pointer ${
                activeFilter === filter
                  ? 'bg-blue-600 text-white shadow-lg'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              {filter}
            </button>
          ))}
        </div>

        {/* News Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {filteredArticles.map((article, index) => (
            <article key={index} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <img
                src={article.image}
                alt={article.title}
                className="w-full h-48 object-cover object-top"
              />
              <div className="p-6">
                <div className="flex items-center justify-between mb-3">
                  <span className="inline-block bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-xs font-medium">
                    {article.category}
                  </span>
                  <span className="text-xs text-gray-500">{article.readTime}</span>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-3 line-clamp-2 leading-tight">
                  {article.title}
                </h3>
                <p className="text-gray-600 mb-4 line-clamp-3 text-sm">
                  {article.summary}
                </p>
                <div className="flex items-center justify-between">
                  <div className="flex flex-col">
                    <span className="text-xs text-gray-500">{article.author}</span>
                    <span className="text-xs text-gray-400">{article.date}</span>
                  </div>
                  <Button variant="outline" size="sm" className="whitespace-nowrap">
                    Read More
                  </Button>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="text-center">
          <Button size="lg" className="bg-red-600 hover:bg-red-700 whitespace-nowrap">
            Load More Articles
          </Button>
        </div>
      </div>
    </section>
  );
}
